(function () {
  'use strict';

  function collapseEmpireNavigation() {
    if (window.innerWidth >= 720) return;

    var header = document.querySelector('[data-site-header]');
    var menuToggle = document.querySelector('[data-site-header] [data-menu-toggle]');

    if (!header) return;

    header.classList.remove('site-header-nav--open');

    if (menuToggle) {
      menuToggle.classList.remove('active');
      menuToggle.setAttribute('aria-expanded', 'false');
    }
  }

  function injectCollectionGridFix() {
    if (!document.body || !document.body.classList.contains('template-collection')) return;
    if (document.getElementById('viviero-collection-grid-square-fix')) return;

    var style = document.createElement('style');
    style.id = 'viviero-collection-grid-square-fix';
    style.textContent = [
      'body.template-collection .productgrid--items .productitem__image-container{width:100%!important;min-width:0!important;}',
      'body.template-collection .productgrid--items .productitem--image-link{display:block!important;width:100%!important;}',
      'body.template-collection .productgrid--items .productitem--image{position:relative!important;display:block!important;width:100%!important;height:auto!important;min-height:0!important;aspect-ratio:1/1!important;margin:0!important;padding:0!important;overflow:hidden!important;background:#fff!important;}',
      'body.template-collection .productgrid--items .productitem--image>img.productitem--image-primary,body.template-collection .productgrid--items .productitem--image>img.productitem--image-alternate{position:absolute!important;inset:0!important;display:block!important;width:100%!important;height:100%!important;max-width:none!important;max-height:none!important;object-fit:cover!important;object-position:center center!important;}',
      'body.template-collection .productgrid--items .productitem--image>[data-rimg-canvas]{position:absolute!important;inset:0!important;width:100%!important;height:100%!important;margin:0!important;padding:0!important;}',
      'body.template-collection .productgrid--items .productgrid--item{align-self:start!important;}',
      '@media(max-width:719px){body.template-collection .productgrid--items .productitem--image{aspect-ratio:1/1!important;}}'
    ].join('');

    document.head.appendChild(style);
  }

  function pageNeedsPaletteNormalizer() {
    return Boolean(document.querySelector('.vmat-card-media img, #viviero-colors-v8 .vcp-card-image img'));
  }

  function loadBaseCustomScript() {
    if (window.__vivieroCustomBaseLoaded || window.__vivieroCustomBaseLoading) return;
    if (!pageNeedsPaletteNormalizer()) return;

    window.__vivieroCustomBaseLoading = true;

    var current = document.currentScript;
    if (!current) {
      current = document.querySelector('script[src*="viviero-custom.js"]');
    }

    if (!current || !current.src) {
      window.__vivieroCustomBaseLoading = false;
      return;
    }

    var source;
    try {
      source = new URL(current.src, window.location.href);
      source.pathname = source.pathname.replace(/viviero-custom\.js$/, 'viviero-custom-base.js');
      source.search = '';
    } catch (error) {
      window.__vivieroCustomBaseLoading = false;
      return;
    }

    var base = document.createElement('script');
    base.src = source.toString();
    base.async = false;
    base.onload = function () {
      window.__vivieroCustomBaseLoaded = true;
      window.__vivieroCustomBaseLoading = false;
    };
    base.onerror = function () {
      window.__vivieroCustomBaseLoading = false;
    };

    document.head.appendChild(base);
  }

  function scheduleBaseCustomScript() {
    if (!pageNeedsPaletteNormalizer()) return;

    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(loadBaseCustomScript, { timeout: 1600 });
    } else {
      window.setTimeout(loadBaseCustomScript, 800);
    }
  }

  injectCollectionGridFix();
  scheduleBaseCustomScript();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      collapseEmpireNavigation();
      window.setTimeout(collapseEmpireNavigation, 400);
    }, { once: true });
  } else {
    collapseEmpireNavigation();
    window.setTimeout(collapseEmpireNavigation, 400);
  }

  window.addEventListener('pageshow', function () {
    window.setTimeout(collapseEmpireNavigation, 250);
  });
})();
